import CodeBlock from "../../common/code_block";
import ErrorCodesLink from "../../common/ErrorCodesLink";
import HeaderWithTag from "../../common/header_with_tag";
import { IGetTransactionDetailsRequest } from "../../types/types";
import TryGetTransactionDetails from "./try";
import { Link } from 'react-router-dom';
import { HOST_API_URL } from "../../config";

const requestCode: IGetTransactionDetailsRequest = {
  ttno: "XRT00020675",
};

const responseCode = `{
  "statusCode": 200,
  "message": "Success",
  "errorCode": null,
  "data": {
    "ttno": "XRT00020675",
    "sender": { },
    "receiver": { },
    "bankDetails": null,
    "amount": 100.0,
    "status": "Ready",
    "origRef": "ORIG123456",
    "date_Paid": null,
    "dated": "2026-08-25T09:14:02Z"
  }
}`;

const failureResponseCode = `{
  "statusCode": 400,
  "message": "Transaction not found",
  "errorCode": "DPI-4002",
  "data": null
}`;

function GetTransactionDetails() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Get Transaction Details</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Get Transaction Details
                  </li>
                </ol>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-7" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">
                      <HeaderWithTag
                        headerText="Get transaction details"
                        headerTag="description"
                      />
                      <p className="text-12">
                        <span className="badge badge-sm bg-blue text-white me-2">
                          GET
                        </span>
                        {HOST_API_URL}/Remittances/GetTransactionDetail?ttno={"{ttno}"}
                      </p>
                      <p className="text-muted text-14" style={{ textAlign: "justify" }}>
                        Retrieves full status and metadata for a single transaction using its identifier.
                        Call this to confirm current state after submission or before performing actions like cancellation.
                      </p>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Path Parameters"
                          headerTag="request"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameter</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Required</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                            </thead>
                            <tbody>
                              
                              <tr>
                                <td>ttno</td>
                                <td>string</td>
                                <td>Transaction number</td>
                                <td>Yes</td>
                                <td>5</td>
                                <td>15</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Response"
                          headerTag="response"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>statusCode</td>
                                <td>integer</td>
                                <td>200 on success, otherwise the failure status</td>
                              </tr>
                              <tr>
                                <td>message</td>
                                <td>string</td>
                                <td>"Success", or the reason for the failure</td>
                              </tr>
                              <tr>
                                <td>errorCode</td>
                                <td>string</td>
                                <td>null on success; a stable DPI-xxxx code on failure</td>
                              </tr>
                              <tr>
                                <td>data.ttno</td>
                                <td>string</td>
                                <td>Transaction ID</td>
                              </tr>
                              <tr>
                                <td>data.sender</td>
                                <td>object</td>
                                <td>Sender details recorded against the transaction</td>
                              </tr>
                              <tr>
                                <td>data.receiver</td>
                                <td>object</td>
                                <td>Receiver details recorded against the transaction</td>
                              </tr>
                              <tr>
                                <td>data.bankDetails</td>
                                <td>object</td>
                                <td>Bank details, for bank payouts</td>
                              </tr>
                              <tr>
                                <td>data.amount</td>
                                <td>decimal</td>
                                <td>Sending amount</td>
                              </tr>
                              <tr>
                                <td>data.status</td>
                                <td>string</td>
                                <td>
                                  Current lifecycle status. A transaction can only be
                                  cancelled or amended while it is still "Ready".
                                </td>
                              </tr>
                              <tr>
                                <td>data.origRef</td>
                                <td>string</td>
                                <td>The origRefNumber you supplied on Send Remittance</td>
                              </tr>
                              <tr>
                                <td>data.date_Paid</td>
                                <td>string</td>
                                <td>When the transaction was paid out, if it has been</td>
                              </tr>
                              <tr>
                                <td>data.dated</td>
                                <td>string</td>
                                <td>When the transaction was created</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={responseCode}
                          codeBlackText="Response Example"
                          codeLanguage="json"
                        />
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={failureResponseCode}
                          codeBlackText="Failure Example"
                          codeLanguage="json"
                        />
                      </div>

                      <ErrorCodesLink />
                    </div>
                  </div>
                </div>
                <div className="col-md-5 pt-5">
                  <h5 className="card-title text-primary">
                     Code Samples
                  </h5>

                  <TryGetTransactionDetails
                    codeBlackTitle="Request Example"
                    transactionDetailsObject={requestCode}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetTransactionDetails;
